import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import { isNullOrUndefined } from './utils';
import { SearchDialect } from './enums';


export class SearchTermMetrics {
    attributes: Array<string>;
    defaultLabel: string;
    effectiveLabel: string;
    enabled: boolean;
    handle: string;
    label: string;
    index: number;
    position: number;
    type: string;
    editEnable: boolean;

    constructor(value?: Partial<SearchTermMetrics>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class SearchSettings extends DrEntity {
    includeBatchSheets: boolean;
    includeCustodianSheets: boolean;
    searchDialect: SearchDialect;
    searchTermMetrics: Array<SearchTermMetrics>;

    constructor(value?: Partial<SearchSettings>) {
        super(value);
        if (value) {
            Object.assign(this, value);

            if (isNullOrUndefined(this.searchDialect)) {
                this.searchDialect = SearchDialect.STANDARD;
            }
        }
    }
}

export class SearchSettingsViewModel extends DrObject {
    model: Partial<SearchSettings>;
    original: Partial<SearchSettings>;

    constructor(value?: Partial<SearchSettings>) {
        super(DrObjectType.SEARCH_SETTINGS);

        if (value) {
            this.model = value;

            if (this.model.searchTermMetrics) {
                this.model.searchTermMetrics.forEach((element, index) => {
                    element.index = index + 1;
                    if (element.defaultLabel === 'Clause') {
                        element.editEnable = true;
                    } else {
                        element.editEnable = false;
                    }
                });
            }
        }

        if (this.model) {
            this.original = new SearchSettings(this.model);

            this.original.searchTermMetrics = new Array<SearchTermMetrics>();

            if (this.model.searchTermMetrics) {
                this.model.searchTermMetrics.forEach((element) => {
                    // TODO: need to add logic to attributes to deep copy, but not needed at this time.
                    this.original.searchTermMetrics.push(new SearchTermMetrics(element));
                });
            }
        }
    }

    isSearchTermMetricDirty(current: SearchTermMetrics, original: SearchTermMetrics): boolean {

        if (current.index !== original.index) {
            return true;
        }

        if (current.position !== original.position) {
            return true;
        }

        if (current.editEnable !== original.editEnable) {
            return true;
        }

        if (current.enabled !== original.enabled) {
            return true;
        }

        if (DrObject.isValueDirty(current.label, original.label)) {
            return true;
        }

        return false;
    }

    isDirty(): boolean {
        if (this.model.includeBatchSheets !== this.original.includeBatchSheets) {
            return true;
        }

        if (this.model.includeCustodianSheets !== this.original.includeCustodianSheets) {
            return true;
        }

        if (this.model.searchDialect !== this.original.searchDialect) {
            return true;
        }

        const count = this.model.searchTermMetrics.length;
        for (let i = 0; i < count; i++) {
            if (this.isSearchTermMetricDirty(this.model.searchTermMetrics[i], this.original.searchTermMetrics[i])) {
                return true;
            }
        }
        return false;
    }
}
